export async function fetchCsrf() {
  const url = "/csrf_meta_tags.json"
  const jsonResponse = await fetch(url)
    .then(response => response.json())

  return jsonResponse?.token
}
